import featureFlags from '@enums/feature-flags';

const creationSources = [
    {
        id: 'priceTag',
        labelKey: 'admin.offerPresets.fromPriceTag',
        hintKey: 'admin.offerPresets.fromPriceTagHint',
        icon: 'mdi-tag-outline',
        configureComponent: 'configure-from-price-tag',
        buildPayload: draft => draft,
        isEnabled: toggleLogic => !!toggleLogic?.[featureFlags.enablePriceTags],
    },
    {
        id: 'mechanicForm',
        labelKey: 'admin.offerPresets.fromMechanicForm',
        hintKey: 'admin.offerPresets.fromMechanicFormHint',
        icon: 'mdi-tune-variant',
        configureComponent: 'configure-from-mechanic-form',
        buildPayload: draft => draft,
        isEnabled: () => true,
    },
];

export default creationSources;
